import { z } from 'zod';
import { CoordinatesSchema, GeoAddressSchema } from '@/modules/location/domain/GeoAddressSchema.ts';
import { WeekdayNameSchema } from '@/modules/location/domain/Weekday.ts';

export const LocationTypeSchema = z.enum(['LOADING', 'UNLOADING']);
export type LocationType = z.infer<typeof LocationTypeSchema>;

export const OpeningTimeSchema = z.object({
    start: z.string(),
    end: z.string(),
    weekday: WeekdayNameSchema,
});
export type OpeningTime = z.infer<typeof OpeningTimeSchema>;

export const LocationSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    geoAddress: GeoAddressSchema,
    openingTimes: z.array(OpeningTimeSchema),
    transferPoint: CoordinatesSchema.nullable(),
    note: z.string().nullable(),
    isCustom: z.boolean(),
    organizationId: z.number().optional(),
    legacyFactoryId: z.number().nullish(),
});

export type Location = z.infer<typeof LocationSchema>;
